"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var abstractComponent_1 = __importDefault(require("./abstractComponent"));
var constants_1 = require("../data/constants");
var NavbarMain = /** @class */ (function (_super) {
    __extends(NavbarMain, _super);
    function NavbarMain() {
        var _this = _super.call(this, constants_1.DATA_NAVBAR_MAIN) || this;
        if (!_this.getElement()) {
            return _this;
        }
        _this.mainNav = _this.getChildElement("[".concat(constants_1.DATA_MAIN_NAV, "]"));
        _this.mainNavToggle = _this.getChildElements("[".concat(constants_1.DATA_MAIN_NAV_TOGGLE, "]"));
        _this.mainNavTarget = _this.getChildElements("[".concat(constants_1.DATA_MAIN_NAV_TARGET, "]"));
        _this.mainNavToggleMobile = _this.getChildElement("[".concat(constants_1.DATA_MAIN_NAV_TOGGLE_MOBILE, "]"));
        _this.mainNavBack = _this.getChildElements("[".concat(constants_1.DATA_MAIN_NAV_BACK, "]"));
        _this.firstLevelMobile = _this.getChildElement("[".concat(constants_1.DATA_FIRST_LEVEL_MOBILE, "]"));
        _this.secondLevelMobile = _this.getChildElement("[".concat(constants_1.DATA_SECOND_LEVEL_MOBILE, "]"));
        _this.thirdLevelMobile = _this.getChildElement("[".concat(constants_1.DATA_THIRD_LEVEL_MOBILE, "]"));
        _this.thirdLevelToggle = _this.getChildElements("[".concat(constants_1.DATA_THIRD_LEVEL_TOGGLE, "]"));
        _this.thirdLevelTarget = _this.getChildElements("[".concat(constants_1.DATA_THIRD_LEVEL_TARGET, "]"));
        _this.htmlTag = document.getElementsByTagName('html')[0];
        _this.bodyTag = document.getElementsByTagName('body')[0];
        _this.header = document.querySelector("[".concat(constants_1.DATA_HEADER, "]"));
        _this.downloadModalOpenerMobile = document.querySelector("[".concat(constants_1.DATA_DOWNLOAD_MODAL_OPEN_MOBILE, "]"));
        _this.toggleMainNav();
        _this.toggleMainNavMobile();
        _this.toggleThirdLevel();
        _this.targetThirdLevel();
        _this.clickOutside();
        return _this;
    }
    /**
     * Mobile: toggle the main-navigation from navbar
     *
     */
    NavbarMain.prototype.toggleMainNavMobile = function () {
        var _this = this;
        this.mainNavToggleMobile.addEventListener('click', function () {
            _this.mainNav.classList.toggle('is-open');
            _this.htmlTag.classList.toggle('nav-is-open');
            _this.bodyTag.classList.toggle('nav-is-open');
            _this.header.classList.toggle('is-open');
            _this.mainNavToggleMobile.classList.toggle('is-open');
            _this.firstLevelMobile.classList.toggle('is-open');
            _this.stepBack();
        });
        this.downloadModalOpenerMobile.addEventListener('click', function () {
            if (_this.mainNavToggleMobile.classList.contains('is-open')) {
                _this.mainNav.classList.toggle('is-open');
                _this.htmlTag.classList.toggle('nav-is-open');
                _this.bodyTag.classList.toggle('nav-is-open');
                _this.header.classList.toggle('is-open');
                _this.mainNavToggleMobile.classList.toggle('is-open');
                _this.firstLevelMobile.classList.toggle('is-open');
            }
        });
    };
    /**
     * Desktop: toggle the main-navigation from navbar
     *
     */
    NavbarMain.prototype.toggleMainNav = function () {
        var _this = this;
        this.mainNavToggle.forEach(function (value) {
            value.addEventListener('click', function () {
                if (value.getAttribute('data-main-nav-toggle') != 'link') {
                    _this.mainNav.classList.add('is-open');
                    _this.header.classList.add('is-open');
                    _this.hideThirdLevel();
                    if (value.classList.contains('is-open')) {
                        _this.mainNav.classList.remove('is-open');
                        _this.header.classList.remove('is-open');
                        _this.hideMainNavTarget(value);
                    }
                    if (value.classList.contains('active')) {
                        _this.showThirdLevel(value);
                    }
                    _this.mainNavToggle.forEach(function (value2) {
                        if (value != value2 && !value.classList.contains('main-navigation__level--first')) {
                            value2.classList.remove('is-open');
                        }
                    });
                    if (!value.classList.contains('main-navigation__level--first')) {
                        value.classList.toggle('is-open');
                    }
                }
                _this.showTarget(value, 2);
                _this.scrollToTop();
                _this.temporarilyInActive(value, 1);
                _this.clickedTargets(value, 1);
            });
        });
    };
    /**
     * Close main navigation if clicked outside of header
     *
     */
    NavbarMain.prototype.clickOutside = function () {
        var _this = this;
        window.addEventListener('click', function () {
            _this.header.classList.remove('is-open');
            _this.mainNav.classList.remove('is-open');
            _this.mainNavToggle.forEach(function (value) {
                value.classList.remove('is-open');
            });
        });
        this.header.addEventListener('click', function (event) {
            event.stopPropagation();
        });
    };
    /**
     * Toggle the third level
     *
     */
    NavbarMain.prototype.toggleThirdLevel = function () {
        var _this = this;
        this.thirdLevelToggle.forEach(function (value) {
            value.addEventListener('click', function () {
                _this.hideThirdLevel();
                _this.showTarget(value, 3);
                _this.clickedTargets(value, 2);
            });
        });
    };
    /**
     * Actions for Targets of third level
     *
     */
    NavbarMain.prototype.targetThirdLevel = function () {
        var _this = this;
        this.thirdLevelTarget.forEach(function (value) {
            value.addEventListener('click', function () {
                _this.clickedTargets(value, 3);
            });
        });
    };
    /**
     * Adding and Removing class show on Targets
     *
     */
    NavbarMain.prototype.showTarget = function (element, level) {
        var _this = this;
        if (level == 2) {
            var secondLeveTargetId_1 = element.getAttribute('data-main-nav-toggle');
            this.mainNavTarget.forEach(function (value) {
                if (value.getAttribute('data-main-nav-target') == secondLeveTargetId_1) {
                    value.classList.add('show');
                    _this.showSecondLevelMobile();
                }
                else {
                    value.classList.remove('show');
                }
            });
        }
        else if (level == 3) {
            var thirdLevelTargetId_1 = element.getAttribute('data-third-level-toggle');
            this.thirdLevelTarget.forEach(function (value) {
                if (value.getAttribute('data-third-level-target') == thirdLevelTargetId_1) {
                    value.classList.add('show');
                    _this.showThirdLevelMobile();
                }
            });
        }
    };
    /**
     * Adding clicked and not-clicked Class for overwrite active Styles
     *
     */
    NavbarMain.prototype.clickedTargets = function (element, level) {
        var _this = this;
        element.classList.toggle('clicked');
        if (level == 1) {
            this.thirdLevelToggle.forEach(function (value) {
                if (value.classList.contains('active')) {
                    value.classList.remove('not-clicked');
                }
                value.classList.remove('clicked');
            });
        }
        else if (level == 2) {
            this.thirdLevelToggle.forEach(function (value) {
                if (value.classList.contains('active') && (element != value)) {
                    value.classList.add('not-clicked');
                }
                else {
                    value.classList.remove('not-clicked');
                }
                value.addEventListener('click', function () {
                    value.classList.add('clicked');
                    _this.hideThirdLevel();
                    _this.showTarget(value, 3);
                    _this.thirdLevelToggle.forEach(function (value2) {
                        if (value != value2) {
                            value2.classList.remove('clicked');
                        }
                    });
                });
            });
        }
        else if (level == 3) {
            this.thirdLevelTarget.forEach(function (value) {
                if (value.classList.contains('active') && (element != value)) {
                    value.classList.add('not-clicked');
                }
                value.addEventListener('click', function () {
                    value.classList.add('clicked');
                    _this.thirdLevelTarget.forEach(function (value2) {
                        if (value != value2) {
                            value2.classList.remove('clicked');
                            if (value2.classList.contains('active')) {
                                value2.classList.add('not-clicked');
                            }
                        }
                        else {
                            if (value2.classList.contains('active')) {
                                value2.classList.remove('not-clicked');
                            }
                        }
                    });
                });
            });
        }
    };
    /**
     *
     * @param element Clicked Nav Element
     * @param level Level of Clicked Element
     */
    NavbarMain.prototype.temporarilyInActive = function (element, level) {
        if (level == 1 && element.classList.contains('is-open') && !element.classList.contains('temp-in-active')) {
            this.mainNavToggle.forEach(function (value) {
                if (!value.classList.contains('is-open') && value.classList.contains('active')) {
                    value.classList.add('temp-in-active');
                }
            });
        }
        else {
            this.mainNavToggle.forEach(function (value) {
                value.classList.remove('temp-in-active');
            });
        }
    };
    /**
     * Removes mainNav Targets show State
     *
     */
    NavbarMain.prototype.hideMainNavTarget = function (element) {
        var mainNavTargetId = element.getAttribute('data-main-nav-toggle');
        this.mainNavTarget.forEach(function (value) {
            if (value.getAttribute('data-main-nav-target') == mainNavTargetId) {
                value.classList.remove('show');
            }
        });
    };
    /**
     * Hides all third Levels
     */
    NavbarMain.prototype.hideThirdLevel = function () {
        this.thirdLevelTarget.forEach(function (value) {
            if (value.getAttribute('data-third-level-target')) {
                value.classList.remove('show');
            }
        });
    };
    /**
     * Shows third Level active Items in relation to second Level active State
     *
     */
    NavbarMain.prototype.showThirdLevel = function (element) {
        var _this = this;
        this.thirdLevelTarget.forEach(function (value) {
            if (value.classList.contains('active')) {
                var targets_1 = value.getAttribute('data-third-level-target');
                _this.thirdLevelTarget.forEach(function (value2) {
                    if (targets_1 == value2.getAttribute('data-third-level-target')) {
                        value2.classList.add('show');
                    }
                });
            }
        });
        var thirdLevelTargetId = element.getAttribute('data-third-level-toggle');
        this.thirdLevelToggle.forEach(function (value) {
            if (value.getAttribute('data-main-nav-target') == thirdLevelTargetId) {
                value.classList.add('show');
            }
            else {
                value.classList.remove('show');
            }
        });
    };
    /**
     * Shows Third Level Mobile
     *
     */
    NavbarMain.prototype.showFirstLevelMobile = function () {
        this.firstLevelMobile.classList.add('is-open');
    };
    /**
     * Shows Second Level Mobile
     *
     */
    NavbarMain.prototype.showSecondLevelMobile = function () {
        this.hideFirstLevelMobile();
        this.secondLevelMobile.classList.add('is-open');
    };
    /**
     * Shows Third Level Mobile
     *
     */
    NavbarMain.prototype.showThirdLevelMobile = function () {
        this.hideSecondLevelMobile();
        this.thirdLevelMobile.classList.add('is-open');
    };
    /**
     * Hide First Level Mobile
     *
     */
    NavbarMain.prototype.hideFirstLevelMobile = function () {
        this.firstLevelMobile.classList.remove('is-open');
    };
    /**
     * Hide Second Level Mobile
     *
     */
    NavbarMain.prototype.hideSecondLevelMobile = function () {
        this.secondLevelMobile.classList.remove('is-open');
        this.mainNavToggle.forEach(function (value) {
            value.classList.remove('clicked');
        });
    };
    /**
     * Hide Third Level Mobile
     *
     */
    NavbarMain.prototype.hideThirdLevelMobile = function () {
        this.thirdLevelMobile.classList.remove('is-open');
    };
    /**
     * Step Back Mobile
     *
     */
    NavbarMain.prototype.stepBack = function () {
        var _this = this;
        this.mainNavBack.forEach(function (button) {
            button.addEventListener('click', function () {
                if (button.getAttribute('data-main-nav-back') === '2') {
                    _this.hideSecondLevelMobile();
                    _this.showFirstLevelMobile();
                }
                else {
                    _this.hideThirdLevelMobile();
                    _this.showSecondLevelMobile();
                }
            });
        });
    };
    NavbarMain.prototype.scrollToTop = function () {
        if (!this.header.classList.contains('is-scrolled') && !this.header.classList.contains('is-top')) {
            if ('scrollRestoration' in history) {
                history.scrollRestoration = 'manual';
            }
            window.scrollTo(0, 0);
        }
    };
    return NavbarMain;
}(abstractComponent_1.default));
exports.default = NavbarMain;
